import Vue from 'vue';
import AudioVisual from './avVisual';

Vue.use(AudioVisual);
